import React, { useEffect, useState } from "react";
import styles from "./AddLeadCard.module.css";
import {
  Modal,
  Box,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useSelector } from "react-redux";
import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";

import { useDispatch } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { getSubDomainAccessStatus } from "../../RolePermissionAccess/RolePermissionAccess";
import {
  getCombinedAssignees,
  getCountryCodeFromCallingCode,
} from "../../CommonFunctions/CommonFunctions";
import { ErrorType } from "../../FormTextInput/types";
import {
  contactToLead,
  resetContactModalState,
} from "../../../pages/app/Manage/InstituteProfile/service/instituteSlice";
import { setToastNotification } from "../../ToastNotification/service/toastNotificationSlice";
import { setContactUpdated } from "../../../pages/app/Inbound/service/ContactsUpdationSlice";
import NewFormTextInput from "../../FormTextInput/NewFormTextInput";
import StaffSkeleton from "../../Skeletons/StaffSkeleton";
import CountryCodePhoneInput from "../../CountryCodePhoneInput/CountryCodePhoneInput";
import AutoCompleteField from "../../AutoCompleteField/AutoCompleteField";
import SourceManager from "../../SourceManager/SourceManager";
import UserAssign from "../../UserAssign/UserAssign";
import FlagAssign from "../../FlagAssign/FlagAssign";
import AdditionalFields from "../../../pages/app/Nurture/components/AddLead/AdditionalFields";
import CancelBtn from "../../Buttons/CancelBtn";
import SaveBtn from "../../Buttons/SaveBtn";
import LeadCallDispositionNote from "./LeadCallDispositionNote";
import {
  setVoxbayDispositionData,
  setVoxbayDispositionDataForEnquiry,
  setVoxbayDispositionFlag,
} from "../../../service/websocketNotificationsSlice";
import LeadCallDispositionComment from "./LeadCardDispositionComment";
import LeadCallDispositionTask from "./LeadCallDispositionTask";
import {
  VoxbayAddLeadForUnknowns,
  resetVoxbayAddLeadForUnknownSuccess,
} from "../../../pages/app/Integrations/service/voxbaySlice";
import { getLeadListByInstituteAndContact } from "../../../pages/app/Nurture/service/nurtureSlice";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: "65%",
    xl: "65%",
    md: "65%",
  },
  maxHeight: "80vh",
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
};

function AddLeadCardForUnknownLeads() {
  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );
  const hasContactsAccess = getSubDomainAccessStatus(
    "INBOUND",
    "CONTACTS",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const { leadBoard } = useSelector((state: any) => state.nurture);
  const swimlaneData = leadBoard?.swimlaneData;
  const leadStages =
    swimlaneData &&
    [...swimlaneData]?.sort((a: any, b: any) => {
      return a?.orderIndex - b?.orderIndex;
    });
  const { courses } = useSelector((state: any) => state.courses);
  const { branchList } = useSelector((state: any) => state.branch);
  const { staffList } = useSelector((state: any) => state.staff);
  const sourceList = leadBoard?.sourceList;
  const { batchList } = useSelector((state: any) => state.batch);
  const {
    instituteDetails,
    contactById,
    contactModalState,
    convertToLeadLoading,
    convertToLeadSuccess,
    contactByIdLoading,
  } = useSelector((state: any) => state.institute);
  const { activeLeadForm } = useSelector((state: any) => state.appSettings);

  const [show, setShow] = useState<boolean>(false);

  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [contactCountryCode, setContactCountryCode] = useState<string>("91");
  const [source, setSource] = useState<any>("");
  const [stage, setStage] = useState<any>("");
  const [priority, setPriority] = useState("NORMAL");
  const [assigny, setAssigny] = useState<any>("");
  const [selectedBatch, setSelectedBatch] = useState<any>("");
  const [selectedCourse, setSelectedCourse] = useState<any>("");
  const [selectedBranch, setSelectedBranch] = useState<any>("");
  const [additionalFields, setAdditionalFields] = useState<any[]>([]);

  const [validStateEmail, setValidStateEmail] = React.useState<boolean>(true);
  const [validStateLastName, setValidStateLastName] =
    React.useState<boolean>(true);
  const [validStateFirstName, setValidStateFirstName] =
    React.useState<boolean>(true);
  const [showErrMsz, setShowErrMsz] = React.useState<boolean>(true);
  const [errorType, setErrorType] = React.useState<ErrorType>("client");
  const [validStateContact, setValidStateContact] =
    React.useState<boolean>(true);
  const [validStateCourse, setValidStateCourse] = React.useState<boolean>(true);
  const [validStateBranch, setValidStateBranch] = React.useState<boolean>(true);
  const [isValidSource, setIsValidSource] = useState(false);

  const setValidateStatusEmail = React.useCallback((val: boolean) => {
    setValidStateEmail(val);
  }, []);
  const setValidateStatusLastName = React.useCallback((val: boolean) => {
    setValidStateLastName(val);
  }, []);
  const setValidateStatusFirstName = React.useCallback((val: boolean) => {
    setValidStateFirstName(val);
  }, []);
  const [noteDetails, setNoteDetails] = React.useState({
    description: "",
    mentionedIds: [],
  });
  const employees = useSelector((state: any) => state.staff.staffList);

  const filteredBranchList = hasAllBranchAccess
    ? branchList
    : branchList?.filter((branch: any) => branch.id === userById?.branchId);

  const filteredBatches = batchList?.filter((batch: any) => {
    const courseMatch =
      selectedCourse?.id === "" || batch.courseId === selectedCourse?.id;
    const branchMatch =
      selectedBranch?.id === "" || batch.branchId === selectedBranch?.id;
    const regularBatch =
      batch.batchConductType === "REGULAR_BATCH" &&
      batch.batchStatus !== "COMPLETED" &&
      batch.status === "ACTIVE";

    return courseMatch && branchMatch && regularBatch;
  });

  const combinedAssignees = getCombinedAssignees(staffList, selectedBranch?.id);
  const instituteFromRedux = useSelector(
    (state: any) => state.institute.instituteDetails
  );

  const mainDispositionReasons = instituteFromRedux?.IVRdispositionReasons;
  const [reasonStageOne, setReasonStageOne] = React.useState<any>("");
  const [reasonStageTwo, setReasonStageTwo] = React.useState<any>("");
  const [reasonStageThree, setReasonStageThree] = React.useState<any>("");
  const [reasonStageOneError, setReasonStageOneError] = React.useState<any>("");
  const [reasonStageTwoError, setReasonStageTwoError] = React.useState<any>("");
  const [reasonStageThreeError, setReasonStageThreeError] =
    React.useState<any>("");
  const [taskRequiredError, setTaskRequiredError] = React.useState<any>("");
  const onReasonChange = React.useCallback((event: any) => {
    setReasonStageOne(event.target.value);
    setReasonStageTwo("");
    setReasonStageThree("");
    setReasonStageOneError("");
  }, []);

  const onReasonTwoChange = React.useCallback((event: any) => {
    setReasonStageTwo(event.target.value);
    setReasonStageThree("");
    setReasonStageTwoError("");
  }, []);

  const onReasonThreeChange = React.useCallback((event: any) => {
    setReasonStageThree(event.target.value);
    setReasonStageThreeError("");
  }, []);

  const [taskDetails, setTaskDetails] = React.useState({
    description: "",
    mentionedIds: [],
  });

  const [addTask, setAddTask] = useState<any>("");
  const [assignyForTask, setAssignyForTask] = useState<any>("");
  const [priorityForTask, setPriorityForTask] = useState<any>("NORMAL");
  const [date, setDate] = useState<any>();
  const [taskType, setTaskType] = useState<string>("CALL");

  const [comment, setComment] = React.useState("");
  const [commentError, setCommentError] = React.useState<any>("");

  const taskTypes = leadBoard?.taskType;

  const onCourseChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedCourse(value);
        setSelectedBatch("");
      } else {
        setSelectedCourse("");
        setSelectedBatch("");
      }
      setValidStateCourse(true);
    },
    []
  );

  const onStageChange = React.useCallback(
    (event: any) => {
      setStage(event.target.value);
    },
    [setStage]
  );

  const onBranchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedBranch(value);
        setSelectedBatch("");
        setValidStateBranch(true);
      } else {
        setSelectedBranch("");
        setSelectedBatch("");
        setValidStateBranch(false);
      }
    },
    []
  );

  const onBatchChange = React.useCallback(
    (event: object, value: any | null) => {
      if (value !== null) {
        setSelectedBatch(value);
        //  setValidStateBatchName(true);
      } else {
        setSelectedBatch("");
        //  setValidStateBatchName(false);
      }
    },
    []
  );

  const onSourceChange = React.useCallback(
    (value: any | null) => {
      if (value !== null) {
        setIsValidSource(false);
        setSource(value);
      } else {
        setSource("");
      }
    },
    [setSource]
  );

  const handleLeadAssignee = React.useCallback(
    (leadId: any, user: any) => {
      setAssigny(user);
    },

    [setAssigny]
  );

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => {
      setPriority(leadPriority);
    },

    [setPriority]
  );
  const handleFieldChange = (updatedFields: any[]) => {
    setAdditionalFields(updatedFields);
  };

  const reset = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setContactCountryCode("91");
    setSelectedBatch("");
    setSelectedCourse("");
    setSelectedBranch("");
    setSource("");
    setStage("");
    setPriority("");
    setAssigny("");
    setValidStateEmail(true);
    setValidStateLastName(true);
    setValidStateFirstName(true);
    setShowErrMsz(true);
    setValidStateContact(true);
    setErrorType("client");
    dispatch(setVoxbayDispositionFlag(null));
    dispatch(setVoxbayDispositionData(null));
    dispatch(setVoxbayDispositionDataForEnquiry(null));
  };

  const onClose = () => {
    setShow(false);
    dispatch(resetContactModalState());
    reset();
    dispatch(setVoxbayDispositionFlag(null));
    dispatch(setVoxbayDispositionData(null));
    dispatch(setVoxbayDispositionDataForEnquiry(null));
  };

  function formatName(name: string) {
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  const { voxbayDispositionFlag, voxbayDispositionData } = useSelector(
    (state: any) => state?.websocketNotifications
  );

  useEffect(() => {
    if (voxbayDispositionData) {
      setPhone(voxbayDispositionData?.destinationNumber);
    }
  }, [voxbayDispositionData]);

  const { voxbayAddLeadForUnknownSuccess, voxbayAddLeadForUnknownLoading } =
    useSelector((state: any) => state.voxbay);

  const AddLead = () => {
    let phoneFormated = phone;
    if (phone === contactCountryCode) {
      phoneFormated = "";
    }

    let body = {
      instituteId: authUser?.institute?.[0]?.instituteId,
      instituteName: authUser?.institute?.[0]?.instituteName,
      studentEmail: email,
      studentFirstName: formatName(firstName),
      studentLastName: formatName(lastName),
      studentContact: phoneFormated,
      contactCountryCode: contactCountryCode,
      courseName: selectedCourse?.courseName,
      courseId: selectedCourse?.id,
      branchName: selectedBranch?.branchName,
      branchId: selectedBranch?.id,
      batchId: selectedBatch?.id ?? "",
      batchName: selectedBatch?.batchName ?? "",
      assignedToName: assigny?.firstName + " " + assigny?.lastName,
      assignedToId: assigny?.id,
      enquirySource: source?.key,
      enquiryStatus: stage?.stateName,
      enquiryStatusId: stage?.id,
      enquiryPriority: priority.toUpperCase(),
      studentContactId: contactById?.id,
      formId:
        contactById?.enquirySource === "WEBFORM"
          ? contactById?.webformId
          : contactById?.enquirySource === "META"
          ? contactById?.streamId
          : "",
      otherDetails: contactById?.otherDetails ?? [],
      createdById: authUser?.institute?.[0]?.id,
      checkDuplicate: true,
      createdByName: authUser?.firstName + " " + authUser?.lastName,
    };

    let emailReg = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,4})+$/;

    const countryCode = getCountryCodeFromCallingCode(contactCountryCode);
    const isPhoneNumberValid = isValidPhoneNumber(
      `+${phoneFormated}`,
      countryCode as CountryCode
    );

    try {
      if (!firstName) {
        dispatch(
          setToastNotification({
            message: String("Please enter first name"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateFirstName(false);
      } else if (phone === contactCountryCode && !email) {
        dispatch(
          setToastNotification({
            message: String("Please enter either phone number or email"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateContact(false);
        setValidStateEmail(false);
      } else if (email && !emailReg?.test(email)) {
        dispatch(
          setToastNotification({
            message: String("Please enter valid email"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        phone?.length > contactCountryCode?.length &&
        !isPhoneNumberValid
      ) {
        dispatch(
          setToastNotification({
            message: "Please enter valid phone number",
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!selectedCourse) {
        dispatch(
          setToastNotification({
            message: String("Please select course"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateCourse(false);
      } else if (!selectedBranch) {
        dispatch(
          setToastNotification({
            message: String("Please select branch"),
            type: "error",
            snackOpen: true,
          })
        );
        setValidStateBranch(false);
      } else if (!source) {
        setIsValidSource(true);
        dispatch(
          setToastNotification({
            message: String("Please select source"),
            type: "error",
            snackOpen: true,
          })
        );
      }
      //    else if (!isValueInList) {
      //     dispatch(
      //       setToastNotification({
      //         message: String("Selected source does'nt exist in source list"),
      //         type: "error",
      //         snackOpen: true,
      //       })
      //     );
      //   }
      else if (!stage) {
        dispatch(
          setToastNotification({
            message: String("Please select stage"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!assigny) {
        dispatch(
          setToastNotification({
            message: String("Please select assignee"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (!priority) {
        dispatch(
          setToastNotification({
            message: String("Please select priority"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        additionalFields?.length > 0 &&
        instituteDetails?.addLeadFormEnabled &&
        additionalFields.some((field) => field.required && !field.fieldValue)
      ) {
        const updatedFields = additionalFields?.map((field) => {
          if (field.required && !field.fieldValue) {
            return { ...field, isValid: false };
          }
          return field;
        });

        setAdditionalFields(updatedFields);
        dispatch(
          setToastNotification({
            message: String("Please fill required additional field"),
            type: "error",
            snackOpen: true,
          })
        );
      } else if (
        additionalFields.length > 0 &&
        instituteDetails?.addLeadFormEnabled &&
        additionalFields.some(
          (field) =>
            field.fieldType === "phone" && !field.isValid && !field.required
        )
      ) {
        dispatch(
          setToastNotification({
            message: String("Please fill valid phone number"),
            type: "error",
            snackOpen: true,
          })
        );
      } else {
        if (reasonStageOne === "") {
          setReasonStageOneError("Please select a reason");
          return;
        }

        // if (addTask === "") {
        //   if (
        //     taskType === "" ||
        //     assigny === "" ||
        //     priority === "" ||
        //     date === "" ||
        //     date === undefined
        //   ) {
        //     setTaskRequiredError(
        //       "Please select task related mandatory field as description is added."
        //     );

        //     return;
        //   }
        // } else {
        //   setTaskRequiredError("");
        // }

        // if (comment === "") {
        //   if (comment === "") {
        //     setCommentError("Please add Comment");
        //     return;
        //   }
        // } else {
        //   setCommentError("");
        // }

        const enrichedPayload = {
          ...body,
          ...(additionalFields.length > 0 &&
            instituteDetails?.addLeadFormEnabled && {
              additionalInfo: additionalFields?.map((field) => ({
                fieldType: field.fieldType,
                fieldLabel: field.fieldName,
                fieldValue: field.fieldValue,
                options: field.options,
                required: field.required,
              })),
            }),
        };
        // dispatch<any>(contactToLead(enrichedPayload));
        let reasonsSet = reasonStageOne?.key;
        if (reasonStageTwo) reasonsSet += `#${reasonStageTwo?.key}`;
        if (reasonStageThree) reasonsSet += `#${reasonStageThree?.key}`;
        const voxbayData = {
          reason: "",
          taskAssignedToName: assigny?.firstName + " " + assigny?.lastName,
          taskAssignedToId: assigny?.id,
          taskPriority: priority,
          taskType: taskType,
          taskDate: date,
          taskDescription: addTask,
          taskMentionedIds: taskDetails?.mentionedIds,
          noteDescription: noteDetails?.description,
          noteMentionedIds: noteDetails?.mentionedIds,
          createdById: authUser?.institute?.[0]?.id,
          createdByName: authUser?.firstName + " " + authUser?.lastName,
          ucid: "",
          appCode: "VOXBAY",
          dispositionResource: {
            callUUID: voxbayDispositionData?.callUUID,
            category: reasonStageOne,
            comment: comment,
            callDetails: voxbayDispositionData,
          },
        };
        dispatch<any>(
          VoxbayAddLeadForUnknowns({
            ...enrichedPayload,
            addDisposition: { ...voxbayData },
          })
        );
      }
    } catch (error) {
      setErrorType("server");
    }
  };

  React.useEffect(() => {
    if (activeLeadForm?.[0]?.additionalFields?.length > 0) {
      const updatedFields = activeLeadForm?.[0]?.additionalFields?.map(
        (item: any, index: number) => ({
          fieldType: item?.field?.fieldType,
          fieldName: item?.field?.fieldName,
          fieldValue: "",
          options: item?.field?.options,
          required: item?.field?.required,
          index: index + 1,
          id: item?.id,
          isValid: true,
          disabled: hasContactsAccess ? false : true,
          countryCode: "",
        })
      );

      setAdditionalFields(updatedFields);
    }
  }, [activeLeadForm, contactModalState]);

  useEffect(() => {
    if (leadBoard && swimlaneData && leadStages?.length > 0) {
      setStage(leadStages[0]);
    }
  }, [setStage, leadBoard]);

  useEffect(() => {
    if (contactById) {
      setFirstName(contactById?.firstName?.replace(/[^a-zA-Z]/g, ""));
      setLastName(contactById?.lastName?.replace(/[^a-zA-Z]/g, ""));
      if (contactById?.contactNumber) {
        const isWebOrMeta =
          contactById?.enquirySource === "WEBFORM" ||
          contactById?.enquirySource === "META";

        const phoneNumber = isWebOrMeta
          ? contactById?.contactNumber
          : `${contactById?.contactNoCountryCode}${contactById?.contactNumber}`;
        setPhone(phoneNumber);
      }
      setEmail(contactById?.email);

      setContactCountryCode(contactById?.contactNoCountryCode);
      let defaultCourse = courses?.find(
        (course: any) => course?.id === contactById?.courseId
      );
      if (defaultCourse) {
        setSelectedCourse(defaultCourse);
      }
      let defaultBranch = branchList?.find(
        (branch: any) => branch?.id === contactById?.branchId
      );
      if (defaultBranch) {
        setSelectedBranch(defaultBranch);
      }
      let defaultBatch = batchList?.find(
        (batch: any) => batch?.id === contactById?.batchId
      );
      if (defaultBatch) {
        setSelectedBatch(defaultBatch);
      }

      const defaultAssigny = staffList?.find(
        (item: any) =>
          item.id === userById?.id && item.branchId === userById?.branchId
      );
      setAssigny(defaultAssigny);
      const contactSource =
        contactById?.enquirySource === "Excel Import"
          ? "EXCEL_IMPORT"
          : contactById?.enquirySource;
      const defaultSource = sourceList?.find(
        (item: any) => item.key === contactSource
      );
      setSource(defaultSource);
    }
  }, [
    contactById,
    courses,
    branchList,
    batchList,
    staffList,
    userById,
    sourceList,
  ]);

  useEffect(() => {
    if (convertToLeadSuccess !== true && convertToLeadSuccess !== false) {
      dispatch(resetContactModalState());
      reset();
      dispatch(setContactUpdated(true));
    }
  }, [convertToLeadSuccess]);

  useEffect(() => {
    if (voxbayAddLeadForUnknownSuccess === true) {
      dispatch(resetContactModalState());
      reset();
      // dispatch(resetVoxbayAddLeadForUnknownSuccess());
      const urlSearchParams = new URLSearchParams(window.location.search);

      const leadInstituteId = urlSearchParams.get("leadInstituteId");
      const leadPhone = urlSearchParams.get("leadPhone");
      const leadEmail = urlSearchParams.get("leadEmail");

      let data: any;
      if (leadInstituteId) {
        if (leadPhone) {
          data = {
            id: leadInstituteId,
            phone: leadPhone,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        } else if (leadEmail) {
          data = {
            id: leadInstituteId,
            email: leadEmail,
          };
          dispatch<any>(getLeadListByInstituteAndContact(data));
        }
      }
    }
  }, [voxbayAddLeadForUnknownSuccess]);

  return (
    <div>
      <Modal
        open={true}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "999999" }}
      >
        <Box sx={style}>
          {contactByIdLoading ? (
            <div className={styles.viewContactSkeletonWrap}>
              <StaffSkeleton />
            </div>
          ) : (
            <>
              <div className={styles.viewContactWrap}>
                <div className={styles.viewContactTitle}>Create Lead</div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      First name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusFirstName}
                      type={"text"}
                      id="firstName"
                      value={firstName}
                      onChange={(e: any) => {
                        const pattern = /^(?:[a-zA-Z\s]*[a-zA-Z][a-zA-Z\s]*)?$/;
                        if (pattern.test(e?.target?.value)) {
                          setFirstName(e?.target?.value);
                        }
                      }}
                      error={!validStateFirstName}
                      showErrorMessage={showErrMsz}
                      errorType={errorType}
                      autoComplete="true"
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Last name
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusLastName}
                      type={"text"}
                      id="lastName"
                      value={lastName}
                      onChange={(e: any) => {
                        const pattern = /^(?:[a-zA-Z\s]*[a-zA-Z][a-zA-Z\s]*)?$/;
                        if (pattern.test(e?.target?.value)) {
                          setLastName(e?.target?.value);
                        }
                      }}
                      error={lastName !== "" ? !validStateLastName : false}
                      showErrorMessage={lastName !== "" ? showErrMsz : false}
                      errorType={errorType}
                      autoComplete="true"
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Email Address
                    </div>
                    <NewFormTextInput
                      validate={true}
                      setValidStatus={setValidateStatusEmail}
                      type={"email"}
                      id="instituteEmail"
                      value={email}
                      onChange={(e: any) => {
                        setShowErrMsz(true);
                        setEmail(e?.target?.value.toLowerCase());
                        setValidStateContact(true);
                      }}
                      error={!validStateEmail}
                      showErrorMessage={showErrMsz}
                      errorType={errorType}
                      autoComplete="true"
                      require={false}
                      inputProps={{
                        maxLength: 50,
                      }}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Phone Number
                    </div>
                    <CountryCodePhoneInput
                      value={phone}
                      onChange={(event: any, country: any) => {
                        if (!phone.startsWith(country.dialCode)) {
                          setPhone(country.dialCode);
                        } else {
                          setPhone(event);
                        }
                        setContactCountryCode(country.dialCode);
                        if (event === country.dialCode || event === "") {
                          setValidStateContact(true);
                        } else {
                          setValidStateContact(
                            isValidPhoneNumber(
                              `+${country.dialCode}${event.replace(
                                country.dialCode,
                                ""
                              )}`,
                              country.countryCode.toUpperCase()
                            )
                          );

                          setValidStateEmail(true);
                        }
                      }}
                      error={validStateContact}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>

                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Course Name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <AutoCompleteField
                      id="courseId"
                      options={courses?.filter(
                        (item: any) => item.status === "ACTIVE"
                      )}
                      optionLabel={"courseName"}
                      onChange={onCourseChange}
                      value={selectedCourse}
                      disableClearable={selectedCourse !== "" ? false : true}
                      required={true}
                      validState={validStateCourse}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Branch name
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <AutoCompleteField
                      id="branchId"
                      options={filteredBranchList}
                      optionLabel={"branchName"}
                      onChange={onBranchChange}
                      value={selectedBranch}
                      disableClearable={selectedBranch !== "" ? false : true}
                      required={true}
                      validState={validStateBranch}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                </div>

                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Batch Name
                    </div>
                    <AutoCompleteField
                      id="batchId"
                      options={filteredBatches}
                      optionLabel={"batchName"}
                      onChange={onBatchChange}
                      value={selectedBatch}
                      disableClearable={selectedBatch !== "" ? false : true}
                      // required={true}
                      validState={true}
                      disabled={!hasContactsAccess}
                    />
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Stage
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    <FormControl
                      size="small"
                      fullWidth
                      sx={{ marginBottom: "12px" }}
                    >
                      <Select
                        onChange={onStageChange}
                        value={stage}
                        sx={{
                          borderRadius: "5px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "5px",
                          },
                        }}
                        disabled={!hasContactsAccess}
                      >
                        {leadStages
                          ?.filter(
                            (stage: any) => stage.stateName !== "CONVERTED"
                          )
                          ?.map((stage: any) => (
                            <MenuItem
                              key={stage.id}
                              value={stage}
                              sx={{
                                color: "#667085",
                                fontSize: "13px",
                                fontWeight: "500",
                              }}
                            >
                              {stage.displayStateName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.viewContactFieldLabel}>
                      Source
                      <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                        *
                      </span>
                    </div>
                    {/* <SourceManager
                      sourceList={sourceList}
                      onSourceChange={onSourceChange}
                      source={source}
                      page={"CONTACT_CARD"}
                      addLead={true}
                      disabled={false}
                      validSource={isValidSource}
                      contactSource={
                        contactById?.enquirySource
                          ? contactById?.enquirySource === "Excel Import"
                            ? "EXCEL_IMPORT"
                            : contactById?.enquirySource
                          : ""
                      }
                    /> */}
                    <SourceManager
                      sourceList={sourceList}
                      onSourceChange={onSourceChange}
                      source={source}
                      page={"UNKNOWN"}
                      addLead={true}
                      disabled={false}
                      validSource={isValidSource}
                    />
                  </div>
                  <div
                    className={styles.contactFieldSplitItem}
                    style={{ display: "flex", gap: "20px" }}
                  >
                    <div className={styles.contactFieldSplitItemSub}>
                      <div className={styles.viewContactFieldLabel}>
                        Assignee{" "}
                        <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                          *
                        </span>
                      </div>
                      <UserAssign
                        users={combinedAssignees}
                        isForEnquiryModal={true}
                        handleLeadAssignee={handleLeadAssignee}
                        selectedAssignyId={assigny?.id}
                        size="xl"
                        disabled={!hasContactsAccess}
                      />
                    </div>
                    <div className={styles.contactFieldSplitItemSub}>
                      <div className={styles.viewContactFieldLabel}>
                        Priority{" "}
                        <span style={{ margin: "0px 4px", color: "#D32F2F" }}>
                          *
                        </span>
                      </div>
                      <FlagAssign
                        isForEnquiryModal={true}
                        handleLeadPriority={handleLeadPriority}
                        selectedPriority={priority}
                        size="xl"
                        disabled={!hasContactsAccess}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  {instituteDetails?.addLeadFormEnabled &&
                    additionalFields?.length > 0 && (
                      <AdditionalFields
                        fields={additionalFields}
                        onFieldChange={handleFieldChange}
                        fieldSplit={true}
                      />
                    )}
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.dispositionPopupFieldLabel}>
                      Choose Reason
                    </div>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      className="formControl"
                      size="small"
                      sx={{ marginBottom: "18px" }}
                    >
                      <Select
                        labelId="stage"
                        id={""}
                        value={reasonStageOne}
                        label=""
                        onChange={onReasonChange}
                        sx={{
                          color: "#667085",
                          borderRadius: "4PX",
                          overflow: "hidden",
                          minHeight: "88px",

                          "&& fieldset": {
                            border: "1px solid rgba(17, 200, 155, 0.10)",
                            borderRadius: "2PX",
                            minHeight: "44px",
                            color: "667085",
                          },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: "1px solid rgba(17, 200, 155, 0.10)",
                              borderRadius: "2PX",
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: "1px solid rgba(17, 200, 155, 0.10)",
                              borderRadius: "2PX",
                            },
                          "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                            {
                              border: "1px solid rgba(17, 200, 155, 0.10)",
                              borderRadius: "2PX",
                            },

                          "&.MuiOutlinedInput-root img": {
                            display: "none",
                          },
                        }}
                        MenuProps={{
                          style: { zIndex: 999999999, fontSize: "14px" },
                          PaperProps: {
                            style: {
                              boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                              border: "1px solid #D4D4D8",
                              borderRadius: "6PX",
                            },
                          },
                        }}
                      >
                        {[
                          { id: 0, value: "Switched Off" },
                          { id: 1, value: "Call Dropped" },
                          { id: 2, value: "Invalid / Wrong Number" },
                          { id: 3, value: "Followup" },
                          { id: 4, value: "Interested" },
                          { id: 5, value: "Not Interested" },
                          { id: 6, value: "Asked to Call Back" },
                          { id: 7, value: "Busy" },
                          { id: 8, value: "Requested WhatsApp / Message" },
                          { id: 9, value: "Budget Concer" },
                        ]?.map((item: any, index: number) => (
                          <MenuItem
                            key={item?.id}
                            value={item?.value}
                            sx={{
                              fontSize: "14PX",
                              color: "#667085",
                              textTransform: "capitalize",
                              fontWeight: "400",
                            }}
                          >
                            {item?.value}
                          </MenuItem>
                        ))}
                      </Select>
                      {reasonStageOneError !== "" && (
                        <FormHelperText
                          error={true}
                          sx={{ marginLeft: "5PX", fontSize: "10PX" }}
                        >
                          {reasonStageOneError}
                        </FormHelperText>
                      )}
                    </FormControl>

                    {/* {reasonStageOne?.subReasons?.length > 0 && (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        className="formControl"
                        size="small"
                        sx={{ marginBottom: "18px" }}
                      >
                        <Select
                          labelId="stage"
                          id={""}
                          value={reasonStageTwo}
                          label=""
                          onChange={onReasonTwoChange}
                          sx={{
                            color: "#667085",
                            borderRadius: "4PX",
                            overflow: "hidden",

                            "&& fieldset": {
                              border: "1px solid rgba(17, 200, 155, 0.10)",
                              borderRadius: "2PX",
                              minHeight: "44px",
                              color: "667085",
                            },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },
                            "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },

                            "&.MuiOutlinedInput-root img": {
                              display: "none",
                            },
                          }}
                          MenuProps={{
                            style: { zIndex: 999999999, fontSize: "14px" },
                            PaperProps: {
                              style: {
                                boxShadow:
                                  "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                                border: "1px solid #D4D4D8",
                                borderRadius: "6PX",
                              },
                            },
                          }}
                        >
                          {reasonStageOne?.subReasons?.map(
                            (item: any, index: number) => (
                              <MenuItem
                                key={index}
                                value={item}
                                sx={{
                                  fontSize: "14PX",
                                  color: "#667085",
                                  textTransform: "capitalize",
                                  fontWeight: "400",
                                }}
                              >
                                {item?.value}
                              </MenuItem>
                            )
                          )}
                        </Select>
                        {reasonStageTwoError && (
                          <FormHelperText
                            error={true}
                            sx={{ marginLeft: "5PX", fontSize: "10PX" }}
                          >
                            {reasonStageTwoError}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}

                    {reasonStageTwo?.subReasons?.length > 0 && (
                      <FormControl
                        fullWidth
                        variant="outlined"
                        className="formControl"
                        size="small"
                        sx={{ marginBottom: "18px" }}
                      >
                        <Select
                          labelId="stage"
                          id={""}
                          value={reasonStageThree}
                          label=""
                          onChange={onReasonThreeChange}
                          sx={{
                            color: "#667085",
                            borderRadius: "4PX",
                            overflow: "hidden",

                            "&& fieldset": {
                              border: "1px solid rgba(17, 200, 155, 0.10)",
                              borderRadius: "2PX",
                              minHeight: "44px",
                              color: "667085",
                            },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },
                            "&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid rgba(17, 200, 155, 0.10)",
                                borderRadius: "2PX",
                              },

                            "&.MuiOutlinedInput-root img": {
                              display: "none",
                            },
                          }}
                          MenuProps={{
                            style: { zIndex: 999999999, fontSize: "14px" },
                            PaperProps: {
                              style: {
                                boxShadow:
                                  "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                                border: "1px solid #D4D4D8",
                                borderRadius: "6PX",
                              },
                            },
                          }}
                        >
                          {reasonStageTwo?.subReasons?.map(
                            (item: any, index: number) => (
                              <MenuItem
                                key={index}
                                value={item}
                                sx={{
                                  fontSize: "14PX",
                                  color: "#667085",
                                  textTransform: "capitalize",
                                  fontWeight: "400",
                                }}
                              >
                                {item?.value}
                              </MenuItem>
                            )
                          )}
                        </Select>
                        {reasonStageThreeError && (
                          <FormHelperText
                            error={true}
                            sx={{ marginLeft: "5PX", fontSize: "10PX" }}
                          >
                            {reasonStageThreeError}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )} */}
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div className={styles.dispositionPopupFieldLabel}>
                      Task
                    </div>

                    <LeadCallDispositionTask
                      taskTypes={taskTypes}
                      employees={employees}
                      setTaskDetails={setTaskDetails}
                      setTaskType={setTaskType}
                      taskType={taskType}
                      setAddTask={setAddTask}
                      setAssigny={setAssigny}
                      assigny={assigny}
                      setPriority={setPriority}
                      priority={priority}
                      setDate={setDate}
                      date={date}
                      addTask={addTask}
                    />
                    {taskRequiredError !== "" && (
                      <FormHelperText
                        error={true}
                        sx={{ marginLeft: "5PX", fontSize: "10PX" }}
                      >
                        {taskRequiredError}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className={styles.contactFieldSplit}>
                  <div className={styles.contactFieldSplitItem}>
                    <div
                      className={styles.dispositionPopupFieldLabel}
                      style={{ marginTop: "20PX" }}
                    >
                      Comment
                    </div>
                    <LeadCallDispositionComment
                      comment={comment}
                      setComment={setComment}
                    />
                    {commentError !== "" && (
                      <FormHelperText
                        error={true}
                        sx={{ marginLeft: "5PX", fontSize: "10PX" }}
                      >
                        {commentError}
                      </FormHelperText>
                    )}
                  </div>
                  <div className={styles.contactFieldSplitItem}>
                    <div
                      className={styles.dispositionPopupFieldLabel}
                      style={{ marginTop: "20PX" }}
                    >
                      Notes
                    </div>
                    <LeadCallDispositionNote
                      noteDetails={noteDetails}
                      setNoteDetails={setNoteDetails}
                      employees={employees}
                    />
                  </div>
                </div>
              </div>

              <div className={styles.contactBtnSplit}>
                <CancelBtn onClick={onClose} />
                <SaveBtn
                  onClick={AddLead}
                  loader={voxbayAddLeadForUnknownLoading}
                  disabled={voxbayAddLeadForUnknownLoading}
                />
              </div>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default AddLeadCardForUnknownLeads;
